module.exports = __webpack_public_path__ + "static/LucasPope3-06fe9c5538f4455c3a33969c097fd822.png";